import { render } from "./TableScopeNotice.vue?vue&type=template&id=4d10ebc8&scoped=true"
import script from "./TableScopeNotice.vue?vue&type=script&lang=js"
export * from "./TableScopeNotice.vue?vue&type=script&lang=js"

import "./TableScopeNotice.vue?vue&type=style&index=0&id=4d10ebc8&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d10ebc8"]])

export default __exports__